export const patientEmail = {
  label: 'Email',
  notProvided: 'Not provided',
  verified: 'Verified',
  actions: {
    add: 'Add email',
    change: 'Change email',
    remove: 'Remove email',
    menu: 'Email actions'
  },
  restrictions: {
    STAFF_USER: "This email is linked to a staff login and can't be changed here.",
    LOGIN_ACTIVE: 'This patient manages their own email from their login.',
    fallback: "This patient's email can't be changed here."
  } as Record<string, string>,
  addPatient: {
    emailLabel: 'Email',
    emailInvalid: 'Enter a valid email address.'
  },
  verifyDialog: {
    titleAdd: 'Add patient email',
    titleChange: 'Change patient email',
    intro: 'Send a 6-digit code to the email. It is saved once the patient reads the code back to you.',
    emailLabel: 'Email',
    emailInvalid: 'Enter a valid email address.',
    clearEmail: 'Clear email',
    consentLabel: (orgName: string) => `Patient agrees to receive email from ${orgName || 'us'}`,
    sendCode: 'Send code',
    sending: 'Sending…',
    codeLabel: 'Verification code',
    codeHelperBeforeSend: 'Send a code to the email first.',
    codeSentExpires: (maskedEmail: string, time: string) => `Code sent to ${maskedEmail}. Expires in ${time}.`,
    expired: 'The code has expired. Resend a new code.',
    resend: 'Resend code',
    resendIn: (seconds: number) => `Resend in ${seconds}s`,
    verify: 'Verify',
    verifying: 'Verifying…',
    attemptsRemaining: (count: number) => `Incorrect code. ${count} ${count === 1 ? 'try' : 'tries'} left.`,
    codeResent: 'A new code was sent.',
    verifiedToast: 'Email verified',
    genericError: "Couldn't complete the request. Try again.",
    cancel: 'Cancel'
  },
  removeDialog: {
    title: 'Remove patient email',
    body: "Remove this patient's email? They will have no email on file until a new one is verified.",
    confirm: 'Remove',
    removedToast: 'Email removed'
  }
} as const;
